import axios from 'axios';
import authService from './authService';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

class AdminService {
  getStats() {
    return axios.get(`${API_URL}/admin/stats`, {
      headers: authService.getAuthHeader()
    });
  }

  getContacts(status = null, skip = 0, limit = 100) {
    let url = `${API_URL}/admin/contacts?skip=${skip}&limit=${limit}`;
    if (status) {
      url += `&status=${status}`;
    }
    return axios.get(url, {
      headers: authService.getAuthHeader()
    });
  }

  updateContactStatus(contactId, status) {
    return axios.put(
      `${API_URL}/admin/contacts/${contactId}/status?status=${status}`,
      {},
      { headers: authService.getAuthHeader() }
    );
  }

  getWarehouses() {
    return axios.get(`${API_URL}/admin/warehouses`, {
      headers: authService.getAuthHeader()
    });
  }

  createWarehouse(warehouse) {
    return axios.post(`${API_URL}/admin/warehouses`, warehouse, {
      headers: authService.getAuthHeader()
    });
  }

  updateWarehouse(warehouseId, warehouse) {
    return axios.put(`${API_URL}/admin/warehouses/${warehouseId}`, warehouse, {
      headers: authService.getAuthHeader()
    });
  }

  deleteWarehouse(warehouseId) {
    return axios.delete(`${API_URL}/admin/warehouses/${warehouseId}`, {
      headers: authService.getAuthHeader()
    });
  }

  getAllContent() {
    return axios.get(`${API_URL}/admin/content/all`, {
      headers: authService.getAuthHeader()
    });
  }

  updateContent(language, section, key, value) {
    return axios.put(
      `${API_URL}/admin/content`,
      { language, section, key, value },
      { headers: authService.getAuthHeader() }
    );
  }

  createAdmin(adminData) {
    return axios.post(`${API_URL}/admin/create`, adminData, {
      headers: authService.getAuthHeader()
    });
  }

  // Lot management
  getLots() {
    return axios.get(`${API_URL}/admin/lots`, {
      headers: authService.getAuthHeader()
    });
  }

  updateLotStatus(lotId, status) {
    return axios.put(`${API_URL}/admin/lots/${lotId}`, { status }, {
      headers: authService.getAuthHeader()
    });
  }

  // Build-to-suit
  getBuildToSuitRequests(status = null) {
    let url = `${API_URL}/admin/build-to-suit`;
    if (status) url += `?status_filter=${status}`;
    return axios.get(url, { headers: authService.getAuthHeader() });
  }

  updateBtsStatus(requestId, status) {
    return axios.put(
      `${API_URL}/admin/build-to-suit/${requestId}/status?new_status=${status}`,
      {},
      { headers: authService.getAuthHeader() }
    );
  }

  // Documents
  getDocuments() {
    return axios.get(`${API_URL}/admin/documents`, {
      headers: authService.getAuthHeader()
    });
  }

  createDocument(doc) {
    return axios.post(`${API_URL}/admin/documents`, doc, {
      headers: authService.getAuthHeader()
    });
  }

  updateDocument(docId, doc) {
    return axios.put(`${API_URL}/admin/documents/${docId}`, doc, {
      headers: authService.getAuthHeader()
    });
  }

  deleteDocument(docId) {
    return axios.delete(`${API_URL}/admin/documents/${docId}`, {
      headers: authService.getAuthHeader()
    });
  }
}

export default new AdminService();
